import {
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroMsk16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroSpb16,
} from '@cian/ui-kit/icons';
import { IIconProps } from '@cian/ui-kit/icons/internal';
import { UndergroundIconWrapper } from '../../components/UndergroundIconWrapper';
import { useOfferCardContext } from '../../context/offerCardContext';
import { FC, useMemo } from 'react';

const metroIcons = new Map<number, FC<IIconProps>>([
  [2, IconMetroSpb16],
  [4743, IconMetroEkb16],
  [4777, IconMetroKzn16],
  [4897, IconMetroNovosib16],
  [4966, IconMetroSam16],
  [4885, IconMetroNN16],
]);

export function UndergroundIconContainer() {
  const {
    generalInfo: { geo },
  } = useOfferCardContext();

  const iconData = useMemo(() => {
    if (!geo?.underground) {
      return;
    }

    return {
      icon: metroIcons.get(geo.regionId) || IconMetroMsk16,
      color: `#${geo.underground.lineColor}`,
    };
  }, [geo]);

  if (!iconData) {
    return null;
  }

  const { icon: Icon, color } = iconData;

  return (
    <UndergroundIconWrapper color={color}>
      <Icon color="current_color" />
    </UndergroundIconWrapper>
  );
}
